import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';

    angular.module('app.principal').controller('DraggableTableCtrl', DraggableTableCtrl);

    DraggableTableCtrl.$inject = ['AuthSvc', 'INVOICE_PARAM'];

    function DraggableTableCtrl(AuthSvc, INVOICE_PARAM) {
        var vm = this;

        vm.filterRow = filterRow;
        vm.tableOptions = { accept: accept };
        vm.remove = remove;
        vm.isZedocEditable = isZedocEditable;
        vm.getZedocList = getZedocList;
        vm.updateLadVisibility = updateLadVisibility;
        vm.updateSaisieVisibility = updateSaisieVisibility;
        vm.filterPresenceOptions = filterPresenceOptions;
        vm.isEditAuthorized = AuthSvc.isEditAuthorized();

        var lightPresenceOptions = INVOICE_PARAM.presenceOptions.slice(1);

        ////////////////////////
        function filterRow(row) {
            if (typeof vm.filterFn === 'function') {
                return vm.filterFn({ data: row });
            }
            return true;
        }

        function accept(srcNodeScope, dstNodeScope, dstIndex) {
            var attr = vm.tableData[dstIndex];
            if (attr.isStandard()) {
                return false;
            }
            return srcNodeScope.$modelValue.section === vm.typeSection;
        }

        function remove(attribute) {
            vm.removeFn({ item: attribute });
        }

        function isZedocEditable(attribute) {
            // Est editable si l'attribut ne fait pas parti du mapping zeDoc standard
            // et si le tableau est editable et si la LAD est activé pour cet attribut
            return attribute.lad && !_isStandardZedoc(attribute) && vm.editable;
        }

        function getZedocList(attribute) {
            return _isStandardZedoc(attribute)
                ? INVOICE_PARAM.zedocStandardParam
                : attribute.multiple
                    ? INVOICE_PARAM.zedocMultiParam
                    : INVOICE_PARAM.zedocMonoParam;
        }

        function _isStandardZedoc(attribute) {
            return (
                !!_.find(INVOICE_PARAM.zedocStandardParam, { id: attribute.mappingLadAuto }) ||
                attribute.path === 'type'
            );
        }

        function updateLadVisibility(attribute) {
            attribute.visibleLad = attribute.presenceLad.visible;
            attribute.lad = attribute.presenceLad.model;
        }

        function updateSaisieVisibility(attribute) {
            attribute.visibleSaisie = attribute.presenceSaisie.visible;
            attribute.saisie = attribute.presenceSaisie.model;
        }

        function filterPresenceOptions(ladSaisie, attribute) {
            if (
                (ladSaisie === 'lad' && attribute.mandatoryLad) ||
                (ladSaisie === 'saisie' && attribute.mandatorySaisie)
            ) {
                return lightPresenceOptions;
            }
            return INVOICE_PARAM.presenceOptions;
        }
    }
})();
